import jwt_decode from 'jwt-decode'
import { validateUserLoginInformation } from './validateUserData';

export const deserializeUserToken = (token) => {
  const data = jwt_decode(token);

  validateUserLoginInformation(data);

  return {
    ...data,
    firstAccess: data.firstAccess === "true",
  }
}